// extracted by mini-css-extract-plugin
export default {"card":"LogicDetailsSidebar_card__NAnTv","logicExplanation":"LogicDetailsSidebar_logicExplanation__kCnrh"};